import React, { FC, Fragment, useEffect, useState } from "react";
import { Grid, Box, Typography, Divider } from "@mui/material";
import { HeaderInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import PracticeApi from "Service/Practice.api";
import DataFormatter from "Utils/DataFormatter";
import {
  FormObjType,
  HandleChangeType,
  HandleClickType
} from "DataTypes/Form";
import { CommonStyle } from "Components";
import ControlledAccord from "Components/Accordion1/Uncontrolled";
import OrganizationFormatter from "Utils/Organization.Formatter";
import {
  ControlledBoxSizeSwitch,
  FormObjSwitch,
} from "Utils/SwitchCases";
import { RouteUrls } from "Constant/RouteUrls";
import CommonFormatter from "Utils/Common.Formatter";
import { FormDataArr, SectionsList, SectionType } from "./Data";
import { ProfileForm } from "Components/SidebarModal/Profile/Data";
import { MedsForm } from "Components/SidebarModal/Meds/Data";
import CstmBtn from "Components/CstmBtn";
import ImgPath from "Constant/Imgs";
import { AllergyForm } from "Components/SidebarModal/Allergy/Data";
import { VitalForm } from "Components/SidebarModal/Vital/Data";
import { VaccineForm } from "Components/SidebarModal/Vaccine/Data";
import { ResultForm } from "Components/SidebarModal/Result/Data";
import { InsuranceForm } from "Components/SidebarModal/Insurance/Data";
import { ContactForm } from "Components/SidebarModal/EmergencyContact/Data";
import { ICD10Form, ProblemForm } from "Components/SidebarModal/Problems/Data";
import RedoxApi from "Service/Redox.api";
import { useDispatch } from "react-redux";
import { setAlertData, setFormLoader } from "Redux/Screen/Action";
import { useNavigate } from "react-router-dom";

interface CstmFormType {
  id: number;
  parentId?: number;
  formArr: FormObjType[]
}

const ManualUpload: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const newProfileForm: FormObjType[] = [{
    id: "patientId",
    label: "Patient Id",
    placeholder: "Enter Patient Id",
    boxType: "input",
    boxSize: 3,
    validatetype: "patientId",
    required: true,
    enableFormLoad: true,
  }, ...ProfileForm];
  const firstInsuranceForm: FormObjType[] = InsuranceForm.map(el => {
    return {
      ...el,
      ...el.id == "priority" ? { inputVal: "Primary" } : {}
    }
  });
  const secondInsuranceForm: FormObjType[] = InsuranceForm.map(el => {
    return {
      ...el,
      ...el.id == "priority" ? { inputVal: "Secondary" } : {}
    }
  })
  const newProblemForm = ProblemForm.map(el => {
    return { ...el, boxSize: 3 }
  })
  const newICD10Form = ICD10Form.map(el => {
    return { ...el, boxSize: 3 }
  })
  const { organization }: HeaderInitialStateType = useSelector(
    (state: any) => state?.header
  );
  const [formArr, setFormArr] = useState<FormObjType[]>([]);
  const [profileForm, setProfileForm] =
    useState<FormObjType[]>(JSON.parse(JSON.stringify(newProfileForm)));
  const [insuranceForm, setInsuranceForm] =
    useState<CstmFormType[]>([{
      formArr: JSON.parse(JSON.stringify(firstInsuranceForm)),
      id: 1
    }]);
  const [contactForm, setContactForm] =
    useState<CstmFormType[]>([{
      formArr: JSON.parse(JSON.stringify(ContactForm)),
      id: 1
    }]);
  const [medsForm, setMedsForm] =
    useState<CstmFormType[]>([{
      formArr: JSON.parse(JSON.stringify(MedsForm)),
      id: 1
    }]);
  const [allergyForm, setAllergyForm] =
    useState<CstmFormType[]>([{
      formArr: JSON.parse(JSON.stringify(AllergyForm)),
      id: 1
    }]);
  const [vitalForm, setVitalForm] =
    useState<CstmFormType[]>([
      // {
      //   formArr: JSON.parse(JSON.stringify(VitalForm)),
      //   id: 1
      // }
    ]);
  const [vaccineForm, setVaccineForm] =
    useState<CstmFormType[]>([
      {
        formArr: JSON.parse(JSON.stringify(VaccineForm)),
        id: 1
      }
    ]);
  const [resultForm, setResultForm] =
    useState<CstmFormType[]>([
      // {
      //   formArr: JSON.parse(JSON.stringify(ResultForm)),
      //   id: 1
      // }
    ]);
  const [problemForm, setProblemForm] =
    useState<CstmFormType[]>([{
      formArr: JSON.parse(JSON.stringify(newProblemForm)),
      id: 1
    }]);
  const [icdForm, setICDForm] =
    useState<CstmFormType[]>([{
      formArr: JSON.parse(JSON.stringify(newICD10Form)),
      id: 1,
      parentId: 1
    }]);

  const handleReset: () => void = () => {
    setProfileForm(JSON.parse(JSON.stringify(newProfileForm)));
    setInsuranceForm([{
      formArr: JSON.parse(JSON.stringify(firstInsuranceForm)),
      id: 1
    }]);
    setContactForm([{
      formArr: JSON.parse(JSON.stringify(ContactForm)),
      id: 1
    }]);
    setMedsForm([{
      formArr: JSON.parse(JSON.stringify(MedsForm)),
      id: 1
    }]);
    setAllergyForm([{
      formArr: JSON.parse(JSON.stringify(AllergyForm)),
      id: 1
    }]);
    // setVitalForm([{
    //   formArr: JSON.parse(JSON.stringify(VitalForm)),
    //   id: 1
    // }]);
    setVaccineForm([{
      formArr: JSON.parse(JSON.stringify(VaccineForm)),
      id: 1
    }]);
    // setResultForm([{
    //   formArr: JSON.parse(JSON.stringify(ResultForm)),
    //   id: 1
    // }]);
    setProblemForm([{
      formArr: JSON.parse(JSON.stringify(newProblemForm)),
      id: 1
    }]);
    setICDForm([{
      formArr: JSON.parse(JSON.stringify(newICD10Form)),
      id: 1,
      parentId: 1
    }])
  }

  const [openSecIds, setOpenSecIds] = useState<SectionType[]>([
    "demographic",
    "insurances",
    "emergency-contacts",
    "medications",
    "problems",
    "allergies",
    "vitals",
    "results",
    "vaccines"
  ]);

  useEffect(() => {
    setData();
    CommonFormatter.HandleNavArr({
      id: "manual-upload",
      label: "Add New Patient",
      path: `/${RouteUrls.hs}/${RouteUrls.organization}` +
        `/${RouteUrls.manualPatientUpload}`,
      level: 2,
      link: RouteUrls.manualPatientUpload,
      navType: "org",
    });
  }, []);

  const setData = async (): Promise<void> => {
    const newFormData: FormObjType[] = JSON.parse(JSON.stringify(FormDataArr));
    const practiceRes = await PracticeApi.read({
      id1: organization.id || null,
    });
    if (practiceRes?.success) {
      const verifiedRes = OrganizationFormatter.VerifyReadResponse(
        practiceRes?.data
      );
      const formatePracticeLocation = DataFormatter.FormatDropdownData(
        verifiedRes.practiceLocations,
        "id",
        "location1",
        "id"
      );
      if (newFormData[0].boxType == "input")
        newFormData[0].inputVal = verifiedRes.name;
      if (newFormData[1].boxType == "single-select") {
        newFormData[1].dropArr = formatePracticeLocation;
        if (formatePracticeLocation.length == 1) {
          const singleLocation = formatePracticeLocation[0];
          const selectedVal = singleLocation.value || singleLocation.id;
          newFormData[1].dropVal = selectedVal;
          newFormData[1].readOnly = true;
        } else {
          newFormData[1].readOnly = false;
        }
      }
      setFormArr(newFormData);
    }
  };

  const handleCstmInputChange: (
    data: HandleChangeType,
    formArr: CstmFormType[],
    parentId: number,
    formObj: FormObjType
  ) => CstmFormType[] = (data, formArr, parentId, formObj) => {
    const newFormArr = formArr.find(el => el.id == parentId);
    if (newFormArr) {
      const newArr = CommonFormatter.HandleInputChange2(
        data, newFormArr.formArr, formObj
      )
      return formArr.map(
        el2 => el2.id == parentId ?
          { ...el2, formArr: newArr } :
          el2)
    } else return formArr
  }

  const handleCstmClickChange: (
    data: HandleClickType,
    formArr: CstmFormType[],
    parentId: number
  ) => CstmFormType[] = (data, formArr, parentId) => {
    const newFormArr = formArr.find(el => el.id == parentId);
    if (newFormArr) {
      const newArr = CommonFormatter.HandleClickChange(
        data, newFormArr.formArr
      )
      return formArr.map(
        el2 => el2.id == parentId ?
          { ...el2, formArr: newArr } :
          el2)
    } else return formArr
  };

  const handleCstmFormAdd: (
    formArr: CstmFormType[],
    sectionId: SectionType,
    level2: boolean,
    parentId?: number
  ) => CstmFormType[] = (formArr, sectionId, level2, parentId) => {
    let newFormArr: FormObjType[] = [];
    const newId = formArr.length == 0 ?
      1 :
      (formArr[formArr.length - 1].id + 1);
    switch (sectionId) {
      case "insurances":
        newFormArr = JSON.parse(JSON.stringify(secondInsuranceForm));
        break;
      case "emergency-contacts":
        newFormArr = JSON.parse(JSON.stringify(ContactForm));
        break;
      case "medications":
        newFormArr = JSON.parse(JSON.stringify(MedsForm));
        break;
      case "allergies":
        newFormArr = JSON.parse(JSON.stringify(AllergyForm));
        break;
      case "vitals":
        newFormArr = JSON.parse(JSON.stringify(VitalForm));
        break;
      case "vaccines":
        newFormArr = JSON.parse(JSON.stringify(VaccineForm));
        break;
      case "results":
        newFormArr = JSON.parse(JSON.stringify(ResultForm));
        break;
      case "problems":
        if (level2) newFormArr = JSON.parse(JSON.stringify(newICD10Form));
        else {
          newFormArr = JSON.parse(JSON.stringify(newProblemForm));
          setICDForm([
            ...icdForm,
            {
              formArr: JSON.parse(JSON.stringify(newICD10Form)),
              id: icdForm.length == 0 ? 1 :
                (icdForm[icdForm.length - 1].id + 1),
              parentId: newId
            }
          ])
        }
        break;
      default: newFormArr = [];
    }
    return [
      ...formArr,
      {
        formArr: newFormArr,
        id: newId,
        ...parentId ? { parentId } : {}
      }
    ]
  };

  const handleCstmDelete: (
    formArr: CstmFormType[],
    formId: number,
    sectionId: SectionType,
    level2: boolean
  ) => CstmFormType[] = (formArr, formId, sectionId, level2) => {
    if (sectionId == "problems" && !level2) {
      setICDForm(icdForm.filter(el => el.parentId != formId))
    }
    return formArr.filter(el => el.id != formId)
  };

  const CstmFormSwitch: (
    secId: SectionType,
    level2?: boolean
  ) => {
    newArr: CstmFormType[];
    head: string;
    setState: React.Dispatch<React.SetStateAction<CstmFormType[]>>
  } = (secId, level2) => {
    switch (secId) {
      case "insurances":
        return {
          newArr: insuranceForm,
          head: "Insurance",
          setState: setInsuranceForm
        };
      case "emergency-contacts":
        return {
          newArr: contactForm,
          head: "Emergency Contact",
          setState: setContactForm
        };
      case "medications":
        return {
          newArr: medsForm,
          head: "Medicine",
          setState: setMedsForm
        };
      case "allergies":
        return {
          newArr: allergyForm,
          head: "Allergy",
          setState: setAllergyForm
        };
      case "problems":
        if (level2) {
          return {
            newArr: icdForm,
            head: "Problem Code",
            setState: setICDForm
          };
        } else {
          return {
            newArr: problemForm,
            head: "Problem",
            setState: setProblemForm
          };
        }
      case "vitals":
        return {
          newArr: vitalForm,
          head: "Vital",
          setState: setVitalForm
        };
      case "vaccines":
        return {
          newArr: vaccineForm,
          head: "Vaccine",
          setState: setVaccineForm
        };
      case "results":
        return {
          newArr: resultForm,
          head: "Result",
          setState: setResultForm
        };
      default:
        return {
          newArr: [],
          head: "",
          setState: setAllergyForm
        };
    }
  };

  const handleAddPatient: () => void = async () => {
    dispatch(setFormLoader(true))
    let validationErrorCheck = false;
    const newformArr = CommonFormatter.HandleValidateForm(formArr);
    validationErrorCheck = newformArr.errorCheck;
    setFormArr(newformArr.formData);
    const newProfileForm = CommonFormatter.HandleValidateForm(profileForm);
    validationErrorCheck = newProfileForm.errorCheck;
    setProfileForm(newProfileForm.formData);
    const newInsForm = insuranceForm.map((el) => {
      const newData = CommonFormatter.HandleValidateForm(el.formArr);
      validationErrorCheck = newData.errorCheck;
      el.formArr = newData.formData;
      return el;
    });
    setInsuranceForm(newInsForm);
    const newContactForm = contactForm.map((el) => {
      const newData = CommonFormatter.HandleValidateForm(el.formArr);
      validationErrorCheck = newData.errorCheck;
      el.formArr = newData.formData;
      return el;
    });
    setContactForm(newContactForm);
    const newMedsForm = medsForm.map((el) => {
      const newData = CommonFormatter.HandleValidateForm(el.formArr);
      validationErrorCheck = newData.errorCheck;
      el.formArr = newData.formData;
      return el;
    });
    setMedsForm(newMedsForm);
    const newProbForm = problemForm.map((el) => {
      const newData = CommonFormatter.HandleValidateForm(el.formArr);
      validationErrorCheck = newData.errorCheck;
      el.formArr = newData.formData;
      return el;
    });
    setProblemForm(newProbForm);
    const newICD10Form = icdForm.map((el) => {
      const newData = CommonFormatter.HandleValidateForm(el.formArr);
      validationErrorCheck = newData.errorCheck;
      el.formArr = newData.formData;
      return el;
    });
    setICDForm(newICD10Form);
    const newAllergyForm = allergyForm.map((el) => {
      const newData = CommonFormatter.HandleValidateForm(el.formArr);
      validationErrorCheck = newData.errorCheck;
      el.formArr = newData.formData;
      return el;
    });
    setAllergyForm(newAllergyForm);
    const newVitalForm = vitalForm.map((el) => {
      const newData = CommonFormatter.HandleValidateForm(el.formArr);
      validationErrorCheck = newData.errorCheck;
      el.formArr = newData.formData;
      return el;
    });
    setVitalForm(newVitalForm);
    const newVaccineForm = vaccineForm.map((el) => {
      const newData = CommonFormatter.HandleValidateForm(el.formArr);
      validationErrorCheck = newData.errorCheck;
      el.formArr = newData.formData;
      return el;
    });
    setVaccineForm(newVaccineForm);
    const newResultForm = resultForm.map((el) => {
      const newData = CommonFormatter.HandleValidateForm(el.formArr);
      validationErrorCheck = newData.errorCheck;
      el.formArr = newData.formData;
      return el;
    });
    setResultForm(newResultForm);
    if (!validationErrorCheck) {
      const payload: any = {};
      const locationForm = newformArr.formData.find(el => el.id == "location");
      payload.practiceId = organization.id || null;
      payload.practiceLocationId =
        locationForm?.boxType == "single-select" ? locationForm.dropVal : null;
      profileForm.forEach(el => {
        payload[el.id] = el.inputVal;
      });
      payload.insurances = [];
      payload.patientAdminContact = [];
      payload.medications = [];
      payload.allergies = [];
      payload.problems = [];
      payload.immunizations = [];
      payload.results = [];
      payload.vitalSigns = [];
      insuranceForm.forEach(el => {
        const newObj: any = {};
        el.formArr.forEach(el1 => {
          newObj[el1.id] = el1.inputVal
        });
        payload.insurances.push(newObj)
      });
      contactForm.forEach(el => {
        const newObj: any = {};
        el.formArr.forEach(el1 => {
          newObj[el1.id] = el1.inputVal
        });
        payload.patientAdminContact.push(newObj)
      });
      medsForm.forEach(el => {
        const newObj: any = {};
        el.formArr.forEach(el1 => {
          newObj[el1.id] = el1.inputVal
        });
        payload.medications.push(newObj)
      });
      problemForm.forEach(el => {
        const newObj: any = { icdCodes: [] };
        el.formArr.forEach(el1 => {
          newObj[el1.id] = el1.inputVal
        });
        const icdArr = icdForm.filter(filEl => filEl.parentId == el.id);
        icdArr.forEach(el3 => {
          const newObj1: any = {};
          el3.formArr.forEach(el4 => {
            newObj1[el4.id] = el4.inputVal
          });
          newObj.icdCodes.push(newObj1);
        })
        payload.problems.push(newObj)
      });
      allergyForm.forEach(el => {
        const newObj: any = {};
        el.formArr.forEach(el1 => {
          newObj[el1.id] = el1.inputVal
        });
        payload.allergies.push(newObj)
      });
      const res = await RedoxApi.AddPatient({ data: payload });
      if (res?.success) {
        dispatch(setAlertData(res?.alert));
        handleReset();
      }
    }
    dispatch(setFormLoader(false))
  }

  const CommonLevel1UI: (
    secId: SectionType,
    level2?: boolean
  ) => JSX.Element = (secId, level2) => {
    const { head, newArr, setState } = CstmFormSwitch(secId, false);
    return (
      <Box>
        {newArr.map((el1, i) => {
          const sequence = i + 1;
          return (
            <Fragment key={el1.id}>
              <Box mb={1} display="flex" justifyContent="space-between">
                <Typography>{head} {sequence}</Typography>
                {secId == "insurances" && sequence == 1 ?
                  <Fragment /> :
                  <Box
                    sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
                    onClick={() => setState(
                      handleCstmDelete(newArr, el1.id, secId, false)
                    )}
                  >
                    <ImgPath.DeleteOutline titleAccess="Delete" />
                  </Box>
                }
              </Box>
              <Grid container rowSpacing={1} columnSpacing={2}>
                {el1.formArr.map((formEl) => {
                  return (
                    <Grid
                      key={formEl.id}
                      item
                      {...{
                        md: formEl.boxSize,
                        lg: formEl.boxSize,
                        xl: formEl.boxSize
                      }}>
                      {FormObjSwitch({
                        formObj: formEl,
                        onClick: async (props) => {
                          setState(handleCstmClickChange(
                            props, newArr, el1.id
                          ))
                        },
                        inputChange: async (props) => {
                          setState(handleCstmInputChange(
                            props, newArr, el1.id, formEl
                          ))
                        },
                      })}
                    </Grid>
                  );
                })}
              </Grid>
              {level2 && (
                <Box ml={2}>
                  <Divider sx={{ mt: 2 }} />
                  {CommonLevel2UI(secId, el1.id)}
                </Box>
              )}
              <Divider sx={{ my: 2 }} />
            </Fragment>
          )
        })}
        {(secId != "insurances" || newArr.length < 2) &&
          (<Box mt={2}>
            <CstmBtn
              label={(newArr.length == 0 ? "Add " : "Add Another ") + head}
              onClick={() => setState(
                handleCstmFormAdd(newArr, secId, false)
              )}
            />
          </Box>)
        }
      </Box>
    )
  };

  const CommonLevel2UI: (
    secId: SectionType,
    parentId: number
  ) => JSX.Element = (secId, parentId) => {
    const { head, newArr, setState } = CstmFormSwitch(secId, true);
    const filteredArr = newArr.filter(el => el.parentId == parentId)
    return (
      <Box>
        {filteredArr.map(el1 => {
          return (
            <Fragment key={el1.id}>
              <Grid container rowSpacing={1} columnSpacing={2}>
                {el1.formArr.map((formEl) => {
                  let showDeleteIcon = false;
                  if (
                    secId == "problems" &&
                    formEl.id == "codeSystemName" &&
                    filteredArr.length > 1
                  ) showDeleteIcon = true
                  return (
                    <Grid
                      key={formEl.id}
                      item
                      {...{
                        md: formEl.boxSize,
                        lg: formEl.boxSize,
                        xl: formEl.boxSize
                      }}>
                      {showDeleteIcon ? (
                        <Box display="flex">
                          <Box width="80%">
                            {FormObjSwitch({
                              formObj: formEl,
                              onClick: async (props) => {
                                setState(handleCstmClickChange(
                                  props, newArr, el1.id
                                ))
                              },
                              inputChange: async (props) => {
                                setState(handleCstmInputChange(
                                  props, newArr, el1.id, formEl
                                ))
                              },
                            })}
                          </Box>
                          <Box
                            width="20%"
                            mt={2}
                            sx={{ ...CommonStyle.sxRowCenter }}
                          >
                            <Box
                              sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
                              onClick={() => setState(
                                handleCstmDelete(newArr, el1.id, secId, true)
                              )}
                            >
                              <ImgPath.DeleteOutline titleAccess="Delete" />
                            </Box>
                          </Box>
                        </Box>
                      ) : (
                        FormObjSwitch({
                          formObj: formEl,
                          onClick: async (props) => {
                            setState(handleCstmClickChange(
                              props, newArr, el1.id
                            ))
                          },
                          inputChange: async (props) => {
                            setState(handleCstmInputChange(
                              props, newArr, el1.id, formEl
                            ))
                          },
                        })
                      )}
                    </Grid>
                  );
                })}
              </Grid>
              <Divider sx={{ my: 2 }} />
            </Fragment>
          )
        })}
        <Box mt={2}>
          <CstmBtn
            label={(newArr.length == 0 ? "Add " : "Add Another ") + head}
            onClick={() => {
              setState(handleCstmFormAdd(newArr, secId, true, parentId))
            }}
          />
        </Box>
      </Box>
    )
  }

  const handleBodySection: (
    sectionId: SectionType
  ) => JSX.Element = (sectionId) => {
    switch (sectionId) {
      case "demographic":
        return (
          <Grid container rowSpacing={1} columnSpacing={2}>
            {profileForm.map((el) => {
              return (
                <Grid
                  key={el.id}
                  item
                  {...{ md: el.boxSize, lg: el.boxSize, xl: el.boxSize }}>
                  {FormObjSwitch({
                    formObj: el,
                    onClick: async (props) => {
                      setProfileForm(
                        CommonFormatter.HandleClickChange(props, profileForm)
                      );
                    },
                    inputChange: async (props) => {
                      setProfileForm(
                        CommonFormatter.HandleInputChange2(props, profileForm)
                      );
                    },
                  })}
                </Grid>
              );
            })}
          </Grid>
        )
      case "insurances":
        return CommonLevel1UI(sectionId)
      case "emergency-contacts":
        return CommonLevel1UI(sectionId)
      case "medications":
        return CommonLevel1UI(sectionId)
      case "allergies":
        return CommonLevel1UI(sectionId)
      case "vitals":
        return CommonLevel1UI(sectionId)
      case "vaccines":
        return CommonLevel1UI(sectionId)
      case "results":
        return CommonLevel1UI(sectionId)
      case "problems":
        return CommonLevel1UI(sectionId, true)
      default:
        return <Fragment>No data found</Fragment>
    }
  }

  return (
    <Box height="91%" sx={{ ...CommonStyle.sxWhiteBox, overflow: "auto" }}>
      <Box sx={{ p: 2 }}>
        <Box display="flex" alignItems="flex-end" mb={2}>
          <Box width="50%" mr={2}>
            <Grid container rowSpacing={1} columnSpacing={2}>
              {formArr && formArr.length > 0
                ? formArr.map(el => {
                  return (
                    <Grid
                      key={el.id}
                      item
                      {...ControlledBoxSizeSwitch(el.boxSize)}
                    >
                      {FormObjSwitch({
                        formObj: el,
                        onClick: async (props) => {
                          setFormArr(CommonFormatter.HandleClickChange(
                            props, formArr
                          ));
                        },
                        inputChange: async (props) => {
                          setFormArr(CommonFormatter.HandleInputChange2(
                            props, formArr
                          ));
                        },
                      })}
                    </Grid>
                  );
                })
                : null}
            </Grid>
          </Box>
        </Box>
        <Box>
          {SectionsList.map(secEl => {
            const sectionOpen = openSecIds.find(openEl => openEl == secEl.id) ?
              true :
              false;
            return (
              <ControlledAccord
                key={secEl.id}
                head={
                  <Typography>{secEl.label}</Typography>
                }
                body={handleBodySection(secEl.id)}
                handleClick={() => {
                  if (sectionOpen) {
                    setOpenSecIds(
                      openSecIds.filter(openEl => openEl != secEl.id)
                    )
                  }
                  else setOpenSecIds([...openSecIds, secEl.id])
                }}
                accordianOpen={sectionOpen}
              />
            )
          })}
        </Box>
        <Box
          textAlign="end"
          sx={{
            mt: 2,
            "& >button": {
              ml: 1,
            },
          }}
        >
          <CstmBtn
            label="Add Patient"
            onClick={handleAddPatient}
            width="10%"
            enableFormLoad={true}
          />
          <CstmBtn
            label={"Cancel"}
            onClick={() => navigate(-1)}
            width="10%"
            btnType="border"
            enableFormLoad={true}
          />
        </Box>
      </Box>
    </Box>
  );
};
export default ManualUpload;
